module.exports = __webpack_public_path__ + "img/box (1).96d88de7.png";